import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef, useState } from 'react';
import './index.scss';

export default function ContentH() {
    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384415335/logo%2012.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384417763/logo%2013.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384416279/logo%2014.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384618994/logo%2015.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384415664/logo%2016.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384417973/logo%2017.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384417157/logo%2018.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384416967/logo%2019.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384416756/logo%2020.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384416479/logo%2021.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384417555/logo%2022.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1766384417388/logo%2023.jpg',
        },


    ];

    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [finalList, setFinalList] = useState<any[]>([]);

    useEffect(() => {
        if (!containerRef.current || list.length === 0) return;
        const GAP = 12;
        const update = () => {
            const containerWidth = containerRef.current!.offsetWidth;
            // 计算卡片宽度
            let cardWidth = 350;
            if (containerWidth <= 1024) {
                cardWidth = 120;
            } else if (containerWidth <= 1440) {
                cardWidth = 208;
            }


            const itemFullWidth = cardWidth + GAP;
            const singleWidth = list.length * itemFullWidth;


            // ⭐ 必须至少 2 份 list（循环块）
            let duplicatedCount = 2;
            // ⭐ 若单份不足 1 屏，则保证至少覆盖 2 屏
            while (singleWidth * duplicatedCount < containerWidth * 2) {
                duplicatedCount++;
            }
            const duplicated = Array.from({ length: duplicatedCount }, () => list).flat();
            setFinalList(duplicated);

            // 动画核心：只移动 1 份宽度
            contentRef.current?.style.setProperty('--move-distance', `${singleWidth}px`);
            contentRef.current?.style.setProperty('--move-duration2', `${list.length * 4.5}s`);

        };

        update();
        const ro = new ResizeObserver(update);
        ro.observe(containerRef.current);
        return () => ro.disconnect();
    }, []);

    return (
        <div className={`editor-index-list-b2`} >
            <div className="index-list-b2-list" ref={containerRef}>
                <div className="index-list-b2-list-content" ref={contentRef}>
                    {finalList.map((itemA: any, index: number) => {
                        return (
                            <div key={index} className="index-list-b2-item">
                                <EcoImg pc={itemA.pc} h5={itemA.h5} className="index-list-b2-item-img" />

                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
